import { CourtsBody } from 'modules/arena/reports/model/bodies';
import { formatHours } from 'modules/arena/reports/model/format';
import { KpiGrid } from 'modules/arena/reports/components/KpiCard';
import { Panel } from 'modules/arena/reports/components/Panel';
import { DataTable } from 'modules/arena/reports/components/DataTable';
import { OccupancyHeatmap } from 'modules/arena/reports/components/OccupancyHeatmap';
import { AreaProps } from 'modules/arena/reports/areas/shared';
import { CapacityBarList } from 'shared/components/charts/CapacityBarList';
import { ProductMixBar } from 'shared/components/charts/ProductMixBar';

export function CourtsArea({ body, meta, controller }: AreaProps<CourtsBody>) {
  const { changeTable, tableLoading } = controller;
  const mix = body.mix.filter((item) => item.value > 0);
  return (
    <div className="flex flex-col gap-6">
      <KpiGrid metrics={body.metrics} meta={meta} />

      <div className="grid grid-cols-1 gap-6 xl:grid-cols-2">
        <Panel title="Uso efetivo por quadra" subtitle="Horas usadas sobre horas disponíveis (fechadas e bloqueadas não contam como disponíveis)">
          <CapacityBarList
            items={body.byCourt.map((court) => ({ ...court, capacity: court.capacity ?? 0 }))}
            formatRatio={(item) => `${formatHours(item.value)} de ${formatHours(item.capacity)}`}
          />
        </Panel>
        <Panel title="Como as horas disponíveis foram usadas" subtitle="Cada hora entra em uma única categoria — sem dupla contagem">
          {mix.length ? (
            <ProductMixBar items={mix} formatValue={formatHours} />
          ) : (
            <p className="text-sm text-ink-secondary">Nenhuma hora disponível no período.</p>
          )}
          <p className="text-xs text-ink-secondary">Temporárias aguardam pagamento: ainda não são uso confirmado.</p>
        </Panel>
      </div>

      <Panel title="Ocupação por dia e faixa de horário" subtitle="Hachurado = fechado ou bloqueado, não é horário livre">
        <OccupancyHeatmap heatmap={body.heatmap} caption="Ocupação das quadras por dia da semana e faixa de horário" />
      </Panel>

      <DataTable title="Quadras" table={body.table} loading={tableLoading} onChange={changeTable} footnote="Valores em horas. Uso efetivo = confirmadas + aulas + torneios." />
    </div>
  );
}
